import { useState } from "react";
import { Link } from "react-router-dom";
const FAQS = [
  {
    q: "How experienced are your teachers?",
    a: "Our instructors average 12+ years of active trading with verified track records. Each faculty member currently trades while teaching, has been through at least two major market crashes, and holds NISM certification as a baseline — not their highest achievement.",
  },
  {
    q: "I'm a woman — are there other female traders in your classes?",
    a: "Yes — about 30% of our students are women, and they consistently show strong risk discipline. We keep women-friendly timings, respectful classroom environments and a separate doubt-clearing option where useful.",
  },
  {
    q: "Can I attend classes online, or is physical attendance mandatory?",
    a: "Physical attendance is preferred for intensive batches because live guidance and hands-on platform training matter for beginners. Weekly revision sessions, Q&A webinars and community discussion are available online as a hybrid option.",
  },
  {
    q: "What exactly will I learn — is it just basic chart reading?",
    a: "Basic chart reading is a small part of Day 1. The full curriculum covers market psychology, volume and multi-timeframe analysis, complete trading systems, options income strategies, risk mathematics, live implementation and post-course mentorship for 12 weeks.",
  },
  {
    q: "I'm in my 40s — is it too late to learn trading?",
    a: "Not at all. Emotional maturity, patience and risk-awareness — all things that come with life experience — are exactly what trading rewards. Many of our most consistent students started later in life.",
  },
  {
    q: "How do I know this isn't just another scam institute?",
    a: "We don't promise guaranteed returns, we show both winning and losing trades, and our office and instructors are traceable — you're welcome to verify our registration, visit our campus, or speak with alumni before enrolling.",
  },
  {
    q: "Do you provide ongoing support after the course ends?",
    a: "Yes — 12 weeks of structured weekly revision, live Q&A, and doubt-clearing calls, followed by lifetime access to our alumni WhatsApp community and quarterly workshops.",
  },
  {
    q: "I work 9-to-6 — can I trade part-time and still be consistent?",
    a: "Absolutely. Many working students do well with swing trading and options-writing strategies that need only 30–60 minutes a day around market open and close.",
  },
  {
    q: "What's the teacher-to-student ratio?",
    a: "We maintain roughly 1:10–25, with weekly revision sessions and a dedicated Q&A series so instructors can adapt to each student's pace.",
  },
  {
    q: "The fee feels like a big investment — are there payment options?",
    a: "Yes — EMI plans and partial-payment options are available. We evaluate applications on commitment, not just upfront payment capacity.",
  },
  {
    q: "I've lost money trading before — can you still help me?",
    a: "Often, past losses make for better students: you already understand risk. We work through what went wrong (no stop-losses, oversized positions, revenge trading) and rebuild with smaller, disciplined position sizes.",
  },
];

export default function Faq() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <div className="page-head">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active">FAQs</li>
          </ol>
          <h1>Frequently Asked Questions</h1>
          <p className="text-mono" style={{ color: "#B9C0F0" }}>
            Straight answers before you enrol.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              {FAQS.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div className="faq-item" key={index}>
                    <button
                      className="faq-q"
                      aria-expanded={isOpen}
                      onClick={() => toggleFaq(index)}
                    >
                      {item.q}
                      <span className="plus">{isOpen ? "−" : "+"}</span>
                    </button>
                    <div
                      className="faq-a"
                      style={{ display: isOpen ? "block" : "none" }}
                    >
                      {item.a}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-paper">
        <div className="container">
          <div className="cta-band text-center">
            <h2>Still have a question?</h2>
            <p className="mb-4">
              Message us directly — a real counsellor replies, not a bot.
            </p>
            <a
              href="https://wa.me/7004654910?text=Hi%2C%20I%20saw%20your%20website%2C%20I%27m%20interested%20in%20your%20courses.%20Could%20you%20share%20more%20details%3F"
              className="btn btn-brass btn-lg"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ask on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
